import AgencyDetailsForm from './AgencyDetailsForm'
import PartnersTeamPage from './PartnersTeamPage'
import PayoutAccountDetailsPage from './PayoutAccountDetailsPage'
import ReferralPageDetailsForm from './ReferralPageDetailsForm'
import { type Partner, type PartnerAdmin, type PartnerPayoutAccount } from './types'
import { TabMenu } from '../reusable/TabMenu'

export default function Settings ({
  partner,
  partnerAdmin,
  partnerPayoutAccount,
  agencyLogoUrl,
  agentPhotoUrl,
  defaultTabId,
  isInitialSetup,
  mapboxAccessToken,
  showTeam,
  showOrganizationSettings,
  showReferrals,
  showPayoutAccountDetails,
}: {
  partner: Partner;
  partnerAdmin: PartnerAdmin;
  partnerPayoutAccount?: PartnerPayoutAccount
  agencyLogoUrl?: string;
  agentPhotoUrl?: string;
  defaultTabId?: string;
  isInitialSetup?: boolean;
  mapboxAccessToken: string;
  showTeam?: boolean;
  showOrganizationSettings?: boolean;
  showReferrals?: boolean;
  showPayoutAccountDetails?: boolean;
}) {
  const tabs = [
    ...showTeam
      ? [{
          id: 'team',
          name: 'Team',
          content: <PartnersTeamPage partnerId={partner.id} />,
        }]
      : [],
    {
      id: 'agency-details',
      name: 'Organization',
      content: (
        <AgencyDetailsForm
          partner={partner}
          partnerAdmin={partnerAdmin}
          isInitialSetup={isInitialSetup}
          showReferralPageInfo={showReferrals}
          showOrganizationSettings={showOrganizationSettings}
        />
      ),
    },
    ...showReferrals
      ? [{
          id: 'referral-page-details',
          name: 'Referral page',
          content: (
            <ReferralPageDetailsForm
              partner={partner}
              agencyLogoUrl={agencyLogoUrl}
              agentPhotoUrl={agentPhotoUrl}
              isInitialSetup={isInitialSetup}
            />
          ),
        }]
      : [],
    ...showPayoutAccountDetails
      ? [{
          id: 'payout-details',
          name: 'Payout bank account',
          content: (
            <PayoutAccountDetailsPage
              partnerPayoutAccount={partnerPayoutAccount}
              isInitialSetup={isInitialSetup}
              mapboxAccessToken={mapboxAccessToken}
            />
          ),
        }]
      : [],
  ]
  return (
    <div className='w-full h-full flex flex-col'>
      <div className='flex flex-row items-start justify-between flex-wrap gap-3 mb-6'>
        <h1 className='heading-lg'>Settings</h1>
      </div>
      <TabMenu defaultTab={defaultTabId ?? (showTeam ? 'team' : 'agency-details')} tabs={tabs} />
    </div>
  )
}
